import { render, staticRenderFns } from "./subGame.vue?vue&type=template&id=527b4f18&scoped=true"
import script from "./subGame.vue?vue&type=script&lang=js"
export * from "./subGame.vue?vue&type=script&lang=js"
import style0 from "./subGame.vue?vue&type=style&index=0&id=527b4f18&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527b4f18",
  null
  
)

export default component.exports